import React from 'react';
import './App.css';

function App() {
  const apps = [
    {
      name: 'Components Library',
      icon: '📚',
      description: 'Shared UI component library and design system',
      path: '/components',
      color: '#1cafa6'
    },
    {
      name: 'Insurance Application',
      icon: '🏥',
      description: 'Insurance management and policy tracking',
      path: '/insurance',
      color: '#0d67b1'
    },
    {
      name: 'Asset Management',
      icon: '📊',
      description: 'Asset tracking and management system',
      path: '/assetmanagement',
      color: '#ee9c21'
    },
    {
      name: 'Himachal Project',
      icon: '🏔️',
      description: 'Himachal Pradesh project application',
      path: '/himachal',
      color: '#1cafa6'
    },
    {
      name: 'Jharkhand Project',
      icon: '🌾',
      description: 'Jharkhand state project application',
      path: '/jharkhand',
      color: '#0d67b1'
    }
  ];

  return (
    <div className="App">
      <div className="container">
        <header className="header">
          <div className="logo-section">
            <img src="/clogo.svg" alt="Cognitonic Systems" className="logo" />
            <div className="title-section">
              <h1>UX Library & Apps | Cognitonic Systems</h1>
              <p className="company-name"></p>
            </div>
          </div>
          <div className="version-badge">v40.0.0</div>
        </header>

        <div className="subtitle-section">
          <h2>UX Library & Applications</h2>
          <p className="environment-tag">
            <span className="status-dot"></span>
            System Integration Testing Environment
          </p>
        </div>

        <div className="apps-grid">
          {apps.map((app, index) => (
            <div 
              key={index} 
              className="app-card"
              style={{ '--card-color': app.color }}
            >
              <div className="app-icon">{app.icon}</div>
              <h3>{app.name}</h3>
              <p>{app.description}</p>
              <a href={app.path} className="app-link">
                Open Application →
              </a>
            </div>
          ))}
        </div>

        <div className="server-info">
          <h3>Server Information</h3>
          <div className="info-grid">
            <div className="info-item">
              <span className="info-label">Port</span>
              <span className="info-value">{window.location.port || '3000'}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Environment</span>
              <span className="info-value">SIT</span>
            </div>
            <div className="info-item">
              <span className="info-label">Status</span>
              <span className="info-value status-online">
                <span className="status-indicator"></span>
                Online
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Version</span>
              <span className="info-value">40.0.0</span>
            </div>
          </div>
        </div>

        <footer className="footer">
          <p>© 2018-2026 Cognitonic Systems | All Rights Reserved</p>
        </footer>
      </div>
    </div>
  );
}

export default App;
